import _ from 'lodash'

import {
  GLOBAL_VARS_SUCCESS,
  GLOBAL_VARS,
  GLOBAL_ROUTES_UPDATE
} from './actions'

// {

//     "permissions": {
//         "behavioral": "none",
//         "mobile_management": "none"
//     },

//             "partner_organization": "narus",
//             "supervisor": "a3e52a9a-9c1b-4ec7-b907-9d4c50929337",
//             "medical_director": "a3e52a9a-9c1b-4ec7-b907-9d4c50929337",
//             "contact_phone_number": "+11111111111"
//         }
//     }
// }

interface State {
  loading: boolean
  params?: {
    id: string
    clientName: string
  } | null
  vars: null
  organizations?: Record<string, {
    name: string
    enrollmentPrefix: number
    entities: Record<string, unknown>
  }>
  settings?: Record<string, unknown>
  tags?: Array<{
    value: string
    label: string
    color: string
  }>
  user?: {
    app_metadata: {
      roles: Array<{
        role: string
        domain: string
        resourceId: string
      }>
      partner_organization: string
      supervisor: string
      medical_director: string
      contact_phone_number: string
    }
  }
  clients?: Array<{
    attributes: string
    clientName: string
    client_tags: string
    display: string
    divisions: unknown[]
    domain: string
    enrollmentPrefix: number
    entity: string
    group_id: string
    organization: string
    selfEnrollment: boolean
    status: string
    visible: boolean
  }>
  permissions?: any
}
const initialState: State = {
  loading: true,
  params: null,
  vars: null
}

export default function reducer (state = initialState, action: any): State {
  switch (action.type) {
    case GLOBAL_VARS:
      return {
        ...state,
        loading: true
      }
    case GLOBAL_VARS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.vars
      }
    case GLOBAL_ROUTES_UPDATE: {
      if (_.isEqual(state.params, action.params)) {
        return state
      }

      return {
        ...state,
        params: action.params
      }
    }

    default:
      return state
  }
}
